import React from "react";
import { MailOpenIcon } from "../../../../../../assets/Icons/MailOpenIcon";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import styles from "./styles.module.scss";

export const Empty = () => {
  const { tCommon: t } = useAppTranslation.Common();

  return (
    <div className={styles.root}>
      <MailOpenIcon />
      <div>{t("chat.messages.empty")}</div>
    </div>
  );
};
